import React, {useEffect} from 'react';
import GTMUtils from 'utils/gtm';
import SHUtils from 'utils/sh-utils';
import {useSelector} from 'react-redux';
import SegmentUtils from 'utils/segment';
import {Box} from '@spothero/ui';
import PropTypes from 'prop-types';
import css from './Home.module.scss';
import {RichText} from 'prismic-reactjs';
import {formatSlices} from 'utils/cms';
import HomeHero from 'pages/home/components/home-hero';
import AppRatingSchemaJsonLd from 'common/app-rating-schema-jsonld';
import MarketingMetas from 'common/marketing-metas';

const Home = ({
    gtmUtilsPush = GTMUtils.push,
    segmentUtilsPage = SegmentUtils.page,
    staticScrollTo = SHUtils.staticScrollTo,
}) => {
    // Returned Values from Prismic
    const {
        body: slices,
        home_page_title: heroTitle,
        home_page_subtitle: heroSubtitle,
        home_hero_background_image: heroBackgroundImage,
        pageType,
    } = useSelector(state => state.page);

    const {
        search: {
            data: {referrer, referrerAffiliate},
        },
    } = useSelector(state => state);

    useEffect(() => {
        gtmUtilsPush({
            event: 'pageview',
            page: 'home',
        });
    }, [gtmUtilsPush]);

    useEffect(() => {
        segmentUtilsPage({
            name: 'Web Landing',
            properties: {
                referrer: referrer || document.referrer,
                'referrer affiliate': referrerAffiliate,
            },
        });
    }, [referrer, referrerAffiliate, segmentUtilsPage]);

    useEffect(() => {
        staticScrollTo();
    }, [staticScrollTo]);

    return (
        <div>
            <MarketingMetas bodyClassNames={css.homePage} />
            <AppRatingSchemaJsonLd />

            <HomeHero
                title={RichText.asText(heroTitle)}
                subtitle={RichText.asText(heroSubtitle)}
                backgroundImageURL={heroBackgroundImage.url}
                pageType={pageType}
            />

            <Box as="main">{formatSlices({slices, pageType})}</Box>
        </div>
    );
};

Home.propTypes = {
    gtmUtilsPush: PropTypes.func,
    segmentUtilsPage: PropTypes.func,
    staticScrollTo: PropTypes.func,
};

export default Home;
